import { render, staticRenderFns } from "./product-batch-stock.vue?vue&type=template&id=3177ad8f"
import script from "./product-batch-stock.vue?vue&type=script&lang=js"
export * from "./product-batch-stock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports